import { Button } from "reactstrap";
import { FiPlusCircle, FiSearch, FiX } from "react-icons/fi";
import { TiTick } from "react-icons/ti";
import { tConv24 } from "utils/dateHelper";
import { FaImage } from "react-icons/fa";

export const studentLessonRecordTableColumns = (action) => [
  {
    id: "actions",
    header: "View",
    accessor: (row) => action(row),
    sortable: false,
    filterable: false,
  },
  {
    id: "lessonDate",
    header: "Lesson Date",
    accessor: (row) => row.lessonDetail?.date,
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonCentre",
    header: "Centre",
    accessor: (row) => row.lessonDetail?.centre,
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonTime",
    header: "Start",
    accessor: (row) => tConv24(row.lessonDetail?.startTime),
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonEndTime",
    header: "End",
    accessor: (row) => tConv24(row.lessonDetail?.endTime),
    sortable: true,
    filterable: true,
  },
  {
    id: "studentName",
    header: "Student Name",
    accessor: (row) =>
      row.studentDetail?.firstName + " " + row.studentDetail?.lastName,
    sortable: true,
    filterable: true,
  },
  {
    id: "subject",
    header: "Subject",
    accessor: (row) => row.lessonDetail?.course?.name,
  },
  {
    id: "lesson",
    header: "Lesson",
    accessor: (row) => row.lessonDetail?.lesson?.name,
  },
  {
    id: "teacherName",
    header: "Teacher Name",
    accessor: (row) => row.lessonDetail?.teacher?.username,
    sortable: true,
    filterable: true,
  },
  {
    id: "Report",
    header: "Report",
    accessor: (row) =>
      row.studentReportAdded ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Attendance",
    header: "Attendance",
    accessor: (row) =>
      row.studentAttendanceRecorded ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Approved",
    header: "Approved",
    accessor: (row) =>
      row.studentReportApproved ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Classwork",
    header: "Classwork",
    accessor: (row) =>
      row?.lessonFiles?.some((file) => file.type === "classwork") ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "In Class Images",
    header: "In Class Images",
    accessor: (row) =>
      row?.lessonFiles?.some((file) => file.type === "in-class") ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
];

export const studentLessonRecordTableActions =
  ({ showModal, canAdd = false, showUploadModal }) =>
  (row) => (
    <div className="actions-right">
      <Button
        color="warning"
        size="sm"
        className={`btn-icon btn-link edit my-0 ${!row.studentReportAdded}`}
        onClick={() =>
          ((canAdd &&
            row.studentAttendanceRecorded &&
            row.lessonDetail?.teacherAttendanceRecorded) ||
            row.studentReportAdded) &&
          showModal(row)
        }
      >
        {row.studentReportAdded ? (
          <FiSearch size={20} />
        ) : canAdd &&
          row.studentAttendanceRecorded &&
          row.lessonDetail?.teacherAttendanceRecorded ? (
          <FiPlusCircle size={20} />
        ) : (
          <FiSearch size={20} className="text-muted" />
        )}
      </Button>
      <Button
        color="warning"
        size="sm"
        className={`btn-icon btn-link edit my-0 ${!row.studentReportAdded}`}
        onClick={() => canAdd && showUploadModal(row)}
      >
        {canAdd && <FaImage />}
      </Button>
    </div>
  );

export const imageTypes = {
  CLASSWORK: "classwork",
  IN_CLASS_IMAGES: "in-class",
};

export const myLessonRecordsTableColumn = (
  action,
  openUploadStudentRecordModal,
) => [
  {
    id: "actions",
    header: "View",
    accessor: (row) => action(row),
    sortable: false,
    filterable: false,
  },
  {
    id: "lessonDate",
    header: "Lesson Date",
    accessor: (row) => row.lessonDetail?.date,
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonCentre",
    header: "Centre",
    accessor: (row) => row.lessonDetail?.centre,
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonTime",
    header: "Start",
    accessor: (row) => tConv24(row.lessonDetail?.startTime),
    sortable: true,
    filterable: true,
  },
  {
    id: "lessonEndTime",
    header: "End",
    accessor: (row) => tConv24(row.lessonDetail?.endTime),
    sortable: true,
    filterable: true,
  },
  {
    id: "studentName",
    header: "Student Name",
    accessor: (row) =>
      row.studentDetail?.firstName + " " + row.studentDetail?.lastName,
    sortable: true,
    filterable: true,
  },
  {
    id: "subject",
    header: "Subject",
    accessor: (row) => row.lessonDetail?.course?.name,
  },
  {
    id: "lesson",
    header: "Lesson",
    accessor: (row) => row.lessonDetail?.lesson?.name,
  },
  {
    id: "Report",
    header: "Report",
    accessor: (row) =>
      row.studentReportAdded ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Classwork",
    header: "Classwork",
    accessor: (row) =>
      row?.lessonFiles?.some((file) => file.type === "classwork") ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Attendance",
    header: "Attendance",
    accessor: (row) =>
      row.studentAttendanceRecorded ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Approved",
    header: "Approved",
    accessor: (row) =>
      row.studentReportApproved ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "Classwork",
    header: "Classwork",
    accessor: (row) =>
      row?.lessonFiles?.some((file) => file.type === "classwork") ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
  {
    id: "In Class Images",
    header: "In Class Images",
    accessor: (row) =>
      row?.lessonFiles?.some((file) => file.type === "in-class") ? (
        <TiTick className="text-success" />
      ) : (
        <FiX className="text-danger" />
      ),
    filterable: true,
  },
];

export const parseDbDataToFormInput = (data) => ({
  ...data,
  inClassPhotos: data.lessonFiles.filter(
    (lessonFile) => lessonFile.type === imageTypes.IN_CLASS_IMAGES,
  ),
  classworkPhotos: data.lessonFiles.filter(
    (lessonFile) => lessonFile.type === imageTypes.CLASSWORK,
  ),
});
